export default __webpack_public_path__ + "static/media/SCADA3.ee25d2e5.gif";